import { reducerWithInitialState } from 'typescript-fsa-reducers';

import { actions } from 'src/actions';
import { ContentLibraryOrgAnalytics } from 'src/types';

export type State = {
  contentLibrary: ContentLibraryOrgAnalytics[];
  year?: number;
  loading: boolean;
};

const initialState: State = {
  contentLibrary: [],
  year: undefined,
  loading: false,
};

const reducer = reducerWithInitialState<State>(initialState)
  .cases(
    [actions.api.analytics.getContentLibraryAnalytics.started],
    (state): State => ({
      ...state,
      loading: true,
    })
  )
  .cases(
    [actions.api.analytics.getContentLibraryAnalytics.done],
    (state, payload): State => ({
      ...state,
      contentLibrary: payload.result.data,
      year: payload.result.year,
      loading: false,
    })
  )
  .cases(
    [actions.api.analytics.getContentLibraryAnalytics.failed],
    (state): State => ({
      ...state,
      loading: false,
    })
  );

export const analytics = { initialState, reducer };
